import { render, staticRenderFns } from "./BrandMediaBreadcrumbs.vue?vue&type=template&id=58cc5318&scoped=true&"
import script from "./BrandMediaBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaBreadcrumbs.vue?vue&type=style&index=0&id=58cc5318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc5318",
  null
  
)

export default component.exports